module.exports={
    "apiUrlBase": "https://development.api.bpc.caregiver.org",
    "clientUrlBase": "https://development.bpc.caregiver.org",
    "initialView": "dashboard"
}
